import { render, staticRenderFns } from "./EmployeeLayout.vue?vue&type=template&id=daa1f774&scoped=true&"
import script from "./EmployeeLayout.vue?vue&type=script&lang=js&"
export * from "./EmployeeLayout.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeLayout.vue?vue&type=style&index=0&id=daa1f774&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa1f774",
  null
  
)

component.options.__file = "EmployeeLayout.vue"
export default component.exports